import { fromJS } from 'immutable';
import {
  DefaultDataGenerator,
  selectPropertyObject,
  findPropertiesByCourseware,
} from '@pearsontechnology/aero-plugin-schema';
import PluginService from '../PluginService';
import ActivityService from '../ActivityService';

import * as keyPaths from './keyPaths';

export const addChildInConfig = (newChild, schema, keyPath, oldConfig) => {
  const schemaProperty = selectPropertyObject(schema, keyPath);
  const isList = schemaProperty && schemaProperty.type === 'list';

  let newValue = newChild;
  if (isList) {
    const oldProperty = oldConfig.getIn(keyPath);
    const oldValue = oldProperty ? oldProperty.toJS() : [];
    newValue = [...oldValue, newChild];
  }

  return oldConfig.setIn(keyPath, newValue);
};

export const createDefaultConfig = (schema) => {
  const generator = new DefaultDataGenerator();
  return generator.generateDefaultData(schema || {});
};

export const getInActivityConfigHelper = (activity, keyPath) => {
  const configKeyPath = [...keyPaths.config, ...keyPath];
  return configKeyPath.reduce((acc, key) => acc && acc[key], activity);
};

export const getInThemeHelper = (activity, keyPath) => {
  const themeKeyPath = [keyPaths.THEME_KEY, ...keyPath];
  return themeKeyPath.reduce((acc, key) => acc && acc[key], activity);
};

export const getInThemeVariantConfigHelper = (activity) => {
  const themeKeyPath = [...keyPaths.THEME_VARIANT_KEYS];
  const variants = themeKeyPath.reduce((acc, key) => acc && acc[key], activity);
  if (!variants) {
    return undefined;
  }
  const defaultVariant = variants.find((variant) => variant.state === 'DEFAULT');
  return defaultVariant?.config;
};

export const safeParseJSON = (stringifiedJSON) => {
  let parsed = stringifiedJSON;
  try {
    parsed = JSON.parse(stringifiedJSON);
  } catch (e) {
    // Oh well, but whatever...
  }
  return parsed;
};

const _getCoursewareProperties = async (activityId) => {
  const { pluginId, version } = await ActivityService.getInActivity(activityId, keyPaths.pluginRef);
  const plugin = await PluginService.getPlugin(pluginId, version);
  const configurationSchema = JSON.parse(plugin.manifest.configurationSchema || '{}');

  return findPropertiesByCourseware(configurationSchema);
};

export const getChildActivities = async (activityId) => {
  const childActivities = [];
  const configurationData = fromJS(await ActivityService.getInActivityConfig(activityId));
  const coursewareProperties = await _getCoursewareProperties(activityId);

  coursewareProperties.forEach((descriptor) => {
    const coursewareProperty = configurationData.getIn(descriptor.path);
    if (typeof coursewareProperty !== 'undefined' && coursewareProperty !== null) {
      childActivities.push({
        path: descriptor.path,
        isList: descriptor.isList,
        coursewareProperty: coursewareProperty.toJS(),
      });
    }
  });
  return childActivities;
};

